import { render, staticRenderFns } from "./lineitemnote.vue?vue&type=template&id=6628f31e&"
import script from "./lineitemnote.vue?vue&type=script&lang=js&"
export * from "./lineitemnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports